<div edsGrid edsSpacing="xxl">
  <div class="container--wide">
    <eds-tabs dropdownLabel="View">
      <ng-container *ngFor="let doc of documents">
        <eds-tab [heading]="doc.title" [tabId]="doc.tabId">
          <div
            class="pdf__wrapper"
            style="height: 700px"
            *ngIf="(doc?.protected && isLoggedIn) || !doc?.protected"
          >
            <ng2-pdfjs-viewer
              [pdfSrc]="doc.pdfLink"
              viewerFolder="/assets/pdfjs"
            ></ng2-pdfjs-viewer>
          </div>
          <div class="pdf__wrapper" *ngIf="doc?.protected && !isLoggedIn">
            <eds-section-title
              [title]="'literature.restricted-document' | translate"
              [subTitle]="'literature.sign-in-to-access' | translate"
            ></eds-section-title>
            <ft-sign-in
              [inputParameters]="{
                skin: 'Basic 2 Columns',
                legacy: false,
                signOut: false
              }"
            ></ft-sign-in>
          </div>
        </eds-tab>
      </ng-container>
    </eds-tabs>
  </div>
</div>
